<template>
  <div>
    <q-dialog :visible="isVisible" :title="'店铺上架商品详情'" width="1100px" :innerScroll="false" :showFooter="false" :loading="loadingBtn" @close="onCancel">
      <div class="content">
        <div class="store-info">
          <div class="store-item">
            <span class="label">店铺名称:</span>
            <span class="value">{{ rowData.storeName }}</span>
          </div>
          <div class="store-item">
            <span class="label">负责人:</span>
            <span class="value">{{rowData.userName}}</span>
          </div>
        </div>
        <search-box-dialog class="search-box">
          <el-form :inline="true" size="mini" :model="searchForm" :rules="rules" ref="searchForm">
            <el-form-item label="商品编码/名称:" prop="skuCode">
              <el-input v-model="searchForm.skuCode" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="上架状态:" prop="state">
              <el-select v-model="searchForm.state" placeholder="全部" multiple collapse-tags clearable style="width: 240px">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="item in listingStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
          </template>
        </search-box-dialog>

        <el-table
          ref="table"
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :data="tableData.list"
          :height="360"
          class="full-width-table"
          border
        >
          <el-table-column label="商品编码" prop="skuCode" show-overflow-tooltip width="140"></el-table-column>
          <el-table-column label="商品名称" prop="goodsName" show-overflow-tooltip min-width="180"></el-table-column>
          <el-table-column label="上架标识" prop="upType" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column label="商品发货周期" prop="sendCycle" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column label="上架状态" prop="state" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column label="原因" prop="reason" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column label="操作人" prop="operUser" show-overflow-tooltip width="70"></el-table-column>
          <el-table-column label="操作时间" prop="lastUpdateDate" show-overflow-tooltip width="160"></el-table-column>
        </el-table>
        <div class="pagination-container" height="auto">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
      <div class="footer-btn">
        <el-button size="mini" @click="onCancel">关闭</el-button>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import searchBoxDialog from '../../components/search-box.vue';
export default {
  name: 'GoodsStoreRecord',
  components: {
    searchBoxDialog,
  },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  mounted() {
    if (this.rowData.state || this.rowData.state === 0) {
      this.$set(this.searchForm, 'state', [this.rowData.state]);
    }
    this.init();
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      rules: {},
      searchForm: {
        skuCode: '',
        state: []
      },
      // 上架状态选项
      listingStatusOptions: [
        { label: '待上架', value: 0 },
        { label: '暂缓上架', value: 1 },
        { label: '无需上架', value: 2 },
        { label: '已上架', value: 3 },
      ],
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.searchForm,
          listNo: this.rowData.listNo,
          storeCode: this.rowData.storeCode,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.$q.newProduct
        .listStoreDetail({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data || {
              list: [],
              pageNum: 1,
              pageSize: 10,
              total: 0,
            };
          } else {
            this.tableData.list = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.tableData.pageNum = 1;
      this.init();
    },
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
  },
};
</script>

<style lang="stylus" scoped>
.content {
  padding: 0 15px;
  max-height: 70vh;
  overflow-y: auto;
}

.store-info {
  display: flex;
  margin: 10px 0;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.store-item {
  margin-right: 30px;
}

.label {
  font-weight: bold;
  margin-right: 5px;
}

.search-box {
  margin-bottom: 15px;
}

>>> .date-range .single-date {
  width: 110px !important;
}

.full-width-table {
  width: 100%;
}

.pagination-container {
  text-align: right;
  padding: 15px 0;
}

.footer-btn {
  text-align: center;
  margin-top: 10px;
}

>>> .dialog-content {
  padding-right: 0 !important;
}

>>> .el-dialog {
  margin-top: 50px !important;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  height: 45.7326%;
  transform: translateY(0%);
  position: relative;
  display: block;
  cursor: pointer;
  border-radius: inherit;
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
  transition: 0.3s background-color;
}
</style>
